import { useState } from "react";
import api, { formatApiErrorDetail } from "@/lib/api";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from "@/components/ui/dialog";
import { Loader2, Send } from "lucide-react";

export function MessageDialog({ target, onClose }) {
  const [form, setForm] = useState({ title: "", body: "" });
  const [saving, setSaving] = useState(false);
  const send = async () => {
    setSaving(true);
    try {
      const { data } = await api.post("/admin/notifications/send", { agent_id: target?.agent?.id || null, ...form });
      toast.success(`Message sent to ${data.sent} agent(s)`);
      setForm({ title: "", body: "" });
      onClose();
    } catch (e) {
      toast.error(formatApiErrorDetail(e.response?.data?.detail));
    } finally {
      setSaving(false);
    }
  };
  return (
    <Dialog open={!!target} onOpenChange={(v) => !v && onClose()}>
      <DialogContent className="max-w-md" data-testid="message-dialog">
        <DialogHeader><DialogTitle>{target?.agent ? `Message ${target.agent.name}` : "Message all agents"}</DialogTitle></DialogHeader>
        <div className="space-y-3">
          <div className="space-y-1.5"><Label className="text-xs">Title</Label><Input value={form.title} onChange={(e) => setForm({ ...form, title: e.target.value })} data-testid="message-title-input" /></div>
          <div className="space-y-1.5"><Label className="text-xs">Message</Label><Textarea rows={4} value={form.body} onChange={(e) => setForm({ ...form, body: e.target.value })} data-testid="message-body-input" /></div>
          <p className="text-xs text-muted-foreground">Delivered to the agent's in-app inbox (bell icon). Not sent by WhatsApp or email.</p>
        </div>
        <DialogFooter><Button onClick={send} disabled={saving || !form.title.trim()} data-testid="send-message-button">{saving ? <Loader2 className="w-4 h-4 animate-spin" /> : <><Send className="w-4 h-4 mr-1" /> Send</>}</Button></DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
